import { POLLING_INTERVALS } from '@/api/query-keys';

/**
 * Active states that warrant fast (5s) polling.
 * RUNNING bots are actively trading; STARTING bots are in boot sequence.
 */
const ACTIVE_STATES = new Set(['running', 'starting']);

/** Slow polling interval for idle/error states (30s). */
const SLOW_INTERVAL = 30_000;

/**
 * Returns the appropriate polling interval (ms) for a given bot runtime state.
 *
 * - `running` / `starting` → 5 000 ms (POLLING_INTERVALS.botStatus)
 * - Everything else (stopped, halted, crashed, stopping, stop_timeout, disabled, undefined) → 30 000 ms
 */
export function getAdaptiveInterval(runtimeState: string | undefined): number {
  if (runtimeState && ACTIVE_STATES.has(runtimeState)) {
    return POLLING_INTERVALS.botStatus;
  }
  return SLOW_INTERVAL;
}

/**
 * Hook wrapper around `getAdaptiveInterval`.
 * Trivial today, but provides a seam for future reactive extensions
 * (e.g. user-configurable intervals, feature flags).
 */
export function useAdaptiveInterval(runtimeState: string | undefined): number {
  return getAdaptiveInterval(runtimeState);
}
